import React, { Component } from "react";
import { Steps, Spin, Tag, message, Divider, List } from "antd";
import { parse, stringify } from "qs";
import moment from "moment";
import Card from "nbugs-mobile-card";
import { connect } from "dva";
import router from "umi/router";
import Container from "../../../../../components/Container";
import setTarget from "../../assets/set-target.svg";
import netEvaluate from "../../assets/net-evaluate.svg";
import standard from "../../assets/standard.svg";
import setMember from "../../assets/set-member.svg";
import CriterionModalView from "../../Project/components/CriterionModal";
import styles from "./index.less";

const { Step } = Steps;
const stepMap = {
  10: 0,
  20: 0,
  30: 1,
  40: 1,
  50: 2,
  60: 3
};
const statusNameMap = {
  "1": "未开始",
  "2": "进行中",
  "3": "已结束"
};

const statusIcon = {
  "1": "#C3C3C3",
  "2": "#1785EC",
  "3": "#C3C3C3"
};

@connect(({ projectDetail, tree }) => ({
  projectInfo: projectDetail.projectInfo,
  spinProps: projectDetail.spinProps,
  templateList: projectDetail.templateList
}))
class Overview extends Component {
  constructor(props) {
    super(props);

    const { search } = window.location; // 换车utils里的GetQueryString
    const query = parse(search.split("?").pop());
    const { currentProjectId, currentProjectName } = query;

    this.state = {
      currentProjectId,
      currentProjectName,
      showCriterionModal: false
    };
  }

  componentDidMount() {
    this.getDetail();
    this.getModalList();
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: "tree/reset"
    });
    dispatch({
      type: "projectDetail/reset"
    });
  }

  getModalList = () => {
    const { currentProjectId } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "projectDetail/fetchModalList",
      payload: {
        projectId: currentProjectId
      }
    });
  };

  getDetail = () => {
    const { currentProjectId } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "projectDetail/fetchProjectInfo",
      payload: {
        projectId: currentProjectId
      }
    });
  };

  handleJump = url => {
    router.push(`${url}${window.location.search}`);
  };

  handleChangeStatus = status => {
    const { currentProjectId } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "projectDetail/fetchUploadStatus",
      payload: {
        projectId: currentProjectId,
        status
      },
      callback: this.getDetail
    });
  };

  // 设置评估标准模板
  handleSetEvaluateTemplate = templateId => {
    const { dispatch } = this.props;
    const { currentProjectId } = this.state;
    dispatch({
      type: "projectDetail/fetchSetEvaluateTemplate",
      payload: {
        templateId,
        projectId: currentProjectId
      },
      callback: this.handleJumpTree
    });
  };

  // 选择指标模板确定后跳转到树页面
  handleJumpTree = () => {
    const { currentProjectId, currentProjectName } = this.state;
    router.push(
      `/supervision/norm/evaluation/overview/criterion?${stringify({
        currentProjectId,
        currentProjectName
      })}`
    );
  };

  handleShowCriterionModal = (current, selectTemplate) => {
    if (selectTemplate) {
      this.handleJumpTree();
    } else {
      this.setState({
        showCriterionModal: true
      });
    }
  };

  handleEvaluate = processStatus => {
    if (processStatus === 50) {
      this.handleJump("/supervision/norm/evaluation/overview/my");
    } else {
      message.error("不在评估时间");
    }
  };

  // 渲染状态tag
  renderStatusTag = status => {
    return (
      <Tag
        style={{
          background: "white",
          border: `1px solid ${statusIcon[status]}`,
          color: `${statusIcon[status]}`
        }}
      >
        {statusNameMap[status]}
      </Tag>
    );
  };

  // 渲染项目基础设置
  renderSettingList = ({ current, selectTemplate, processStatus }) => {
    return (
      <>
        <div
          className="tool-item"
          onClick={() =>
            this.handleJump("/supervision/norm/evaluation/overview/member")
          }
        >
          <img src={setMember} alt="" />
          <div>项目成员信息</div>
        </div>
        <div
          className="tool-item"
          onClick={() =>
            this.handleJump("/supervision/norm/evaluation/overview/target")
          }
        >
          <img src={setTarget} alt="" />
          <div>项目督查对象</div>
        </div>
        <div
          className="tool-item"
          onClick={() => this.handleEvaluate(processStatus)}
        >
          <img src={netEvaluate} alt="" />
          <div>网络评估</div>
        </div>
        <div
          className="tool-item"
          onClick={() => this.handleShowCriterionModal(current, selectTemplate)}
        >
          <img src={standard} alt="" />
          <div>评估标准</div>
        </div>
      </>
    );
  };

  render() {
    const { showCriterionModal } = this.state;
    const { projectInfo, spinProps, templateList } = this.props;
    const {
      principalList,
      status,
      processStatus,
      projectName,
      introduction,
      selectTemplate,
      startTime,
      endTime
    } = projectInfo;
    const current = stepMap[processStatus];

    const containerProps = {
      breStates: true,
      version: 2,
      defaultPadding: true,
      isSplitBar: true
    };

    return (
      <Container {...containerProps}>
        <div className={styles.overview}>
          <Spin {...spinProps}>
            <div className="first_part">
              <div className="title">
                <div className="left">
                  <span className="verticalBar" />
                  <span>
                    {projectName}
                    {this.renderStatusTag(status)}
                  </span>
                </div>
              </div>
              <Divider />
              <div className="projectNews">
                <List.Item>
                  <span className="itemName">负责人</span>:
                  <span style={{ marginLeft: 16 }}>
                    {principalList &&
                      principalList.map(item => `${item.userName}  `)}{" "}
                  </span>
                </List.Item>
                <List.Item>
                  <span className="itemName">项目计划时间</span>:
                  <span style={{ marginLeft: 16 }}>
                    {startTime && moment(startTime).format("YYYY.MM.DD")} ~{" "}
                    {endTime && moment(endTime).format("YYYY.MM.DD")}
                  </span>
                </List.Item>
              </div>
            </div>
            <div className="second_part">
              <Divider orientation="left">项目介绍</Divider>
              <div>
                {introduction && (
                  <Card maxHeight={160} wrapShowMode="normal">
                    <div dangerouslySetInnerHTML={{ __html: introduction }} />
                  </Card>
                )}
              </div>
              <div className="tool-wrap-set">
                <Divider orientation="left">项目基础设置</Divider>
                <div className="tool-content">
                  {this.renderSettingList({
                    current,
                    selectTemplate,
                    processStatus
                  })}
                </div>
              </div>
              <div className="step-wrap">
                <Divider orientation="left">项目工作流程</Divider>
                <div className="step-content">
                  <Steps
                    className="step-process"
                    progressDot
                    size="small"
                    current={selectTemplate ? current : 0}
                  >
                    <Step
                      title={!selectTemplate ? "请设置评估标准" : "评估标准"}
                      onClick={() =>
                        this.handleShowCriterionModal(current, selectTemplate)
                      }
                    />
                    <Step
                      title={
                        processStatus === 30 ? "正在自查自评中" : "自查自评"
                      }
                    />
                    <Step
                      title={processStatus === 50 ? "正在评估中" : "评估"}
                      onClick={() => this.handleEvaluate(processStatus)}
                    />
                    <Step title="发布报告" />
                  </Steps>
                </div>
              </div>
            </div>
            {showCriterionModal && (
              <CriterionModalView
                onCancel={() => this.setState({ showCriterionModal: false })}
                templateList={templateList}
                handleSetEvaluateTemplate={templateId =>
                  this.handleSetEvaluateTemplate(templateId)
                }
              />
            )}
          </Spin>
        </div>
      </Container>
    );
  }
}

export default Overview;
